module.exports = __webpack_public_path__ + "img/prod-7.3b74931b.png";